import { html } from "lit";
import { when } from "lit/directives/when.js";
import { tokenMap } from "../../../../common/utils";
import { copy, getMessageSerializedContentAll } from "../../utils";
export const defaultActionsRender = (message, chatRef) => {
    const { accessibleName, text } = chatRef.translations;
    return when(message.role === "assistant" &&
        (message.status === "complete" || !message.status), () => html `<button
      aria-label=${
    // TODO: Don't set aria-label if it equals to the caption
    accessibleName.copyMessageContent}
      part=${tokenMap({
        [`assistant copy-message-content ${message.id}`]: true,
        [message.parts]: !!message.parts
    })}
      type="button"
      @click=${
    // We use the whole message to support copying the files and/or sources
    copy(getMessageSerializedContentAll(message))}
    >
      ${text.copyMessageContent}
    </button>`);
};
